// ##############################
// // // groups
// #############################
var IMGDIR = process.env.REACT_APP_IMGDIR;

const groups = [
    {avatar: IMGDIR+"/images/social/groups/group-2.jpg", name: "Technology", position: "6 months ago", age: "315 members"},
    {avatar: IMGDIR+"/images/social/groups/group-1.jpg", name: "Art", position: "1 year ago", age: "121 members"},
    {avatar: IMGDIR+"/images/social/groups/group-7.jpg", name: "Music", position: "1 year ago", age: "532 members"},
    {avatar: IMGDIR+"/images/social/groups/group-3.jpg", name: "Culture", position: "10 months ago", age: "251 members"},
    {avatar: IMGDIR+"/images/social/groups/group-5.jpg", name: "Travel", position: "11 months ago", age: "25 members"},
    {avatar: IMGDIR+"/images/social/groups/group-4.jpg", name: "Adventure", position: "3 years ago", age: "350 members"},
    {avatar: IMGDIR+"/images/social/groups/group-6.jpg", name: "College", position: "2 years ago", age: "544 members"},
    {avatar: IMGDIR+"/images/social/groups/group-9.jpg", name: "Fitness", position: "5 months ago", age: "35 members"},
]; 

export {
    groups, 
};
